import { render, staticRenderFns } from "./PolicyViolationAudit.vue?vue&type=template&id=219e70f6&"
import script from "./PolicyViolationAudit.vue?vue&type=script&lang=js&"
export * from "./PolicyViolationAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219e70f6')) {
      api.createRecord('219e70f6', component.options)
    } else {
      api.reload('219e70f6', component.options)
    }
    module.hot.accept("./PolicyViolationAudit.vue?vue&type=template&id=219e70f6&", function () {
      api.rerender('219e70f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/PolicyViolationAudit.vue"
export default component.exports